<template>
  <v-card>
    <v-card-title>
      {{ creatingTerminal ? 'Agregar terminal e integración' : 'Agregar integración' }}
      <v-spacer />
      <v-btn icon @click="cancel">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <p>
        Compañía: <strong>{{ company.companyName }}</strong>
      </p>
      <p v-if="terminal">
        Terminal: <strong>{{ terminal.code_store }}</strong>
      </p>
      <v-alert v-if="creatingTerminal" type="info" text>
        El código de terminal HIOPOS del Excel creará una terminal nueva con un
        Token general y guardará la integración seleccionada. El establecimiento
        es opcional y solo tiene uso informativo.
      </v-alert>
      <v-alert v-else type="info" text>
        El Excel debe contener el código de la terminal seleccionada. El
        establecimiento es opcional y no modifica la identidad de la terminal.
      </v-alert>

      <v-row>
        <v-col cols="12" md="6">
          <v-select
            v-model="provider"
            :items="providerOptions"
            item-text="text"
            item-value="value"
            item-disabled="disabled"
            label="Proveedor"
            prepend-inner-icon="mdi-credit-card-multiple"
          />
        </v-col>

        <v-col cols="12" md="6">
          <v-select
            v-model="typeTef"
            :items="availableTypes"
            item-text="text"
            item-value="value"
            label="Tipo de integración"
            prepend-inner-icon="mdi-connection"
            :disabled="!provider"
          />
        </v-col>
      </v-row>

      <v-btn
        v-if="typeTef"
        text
        color="primary"
        class="mb-3"
        @click="downloadFormat"
      >
        <v-icon left>mdi-download</v-icon>
        Descargar formato base
      </v-btn>

      <v-alert
        v-if="provider === 'WOMPI'"
        type="info"
        text
      >
        Wompi todavía no tiene modalidades registradas en el catálogo TEF.
      </v-alert>

      <v-alert
        v-if="provider && !availableTypes.length && provider !== 'WOMPI'"
        type="warning"
        text
      >
        Esta terminal no puede agregar otra modalidad de este proveedor o ya
        tiene una integración entre aplicaciones que impide combinarla.
      </v-alert>

      <v-alert
        v-if="providerConfigured"
        type="warning"
        text
      >
        Esta terminal ya tiene configurada una integración de este proveedor.
      </v-alert>

      <v-file-input
        v-if="typeTef"
        v-model="file"
        accept=".xlsx,.xls"
        label="Archivo Excel de configuración"
        prepend-icon="mdi-file-excel"
        @change="loadExcel"
      />

      <v-alert
        v-if="rows.length"
        type="info"
        text
      >
        Se encontraron {{ rows.length }} terminales para configurar.
        La operación será guardada completa o rechazada.
      </v-alert>

      <v-alert v-if="message" :type="messageType" text>
        {{ message }}
      </v-alert>
    </v-card-text>

    <v-card-actions class="justify-end">
      <v-btn text @click="cancel">
        Cancelar
      </v-btn>
      <v-btn
        dark
        style="background-color: rgb(204 33 40); color: white !important;"
        :disabled="
          !rows.length || saving || provider === 'WOMPI' || providerConfigured
        "
        @click="save"
      >
        {{ saving ? 'GUARDANDO...' : 'GUARDAR INTEGRACIÓN' }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import readXlsFile from 'read-excel-file'
import { listTef } from '@/data/listTef'

export default {
  name: 'AddIntegrationBulkTef',

  props: {
    company: {
      type: Object,
      required: true
    },
    terminal: {
      type: Object,
      default: null
    },
    creatingTerminal: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      provider: null,
      typeTef: null,
      file: null,
      rows: [],
      saving: false,
      message: '',
      messageType: 'info',
      providers: [
        { text: 'Credibanco', value: 'CREDIBANCO' },
        { text: 'Redeban (En desarrollo)', value: 'REDEBAN', disabled: true },
        { text: 'Wompi (No disponible)', value: 'WOMPI', disabled: true }
      ],
      typeRules: {
        1: { provider: 'CREDIBANCO', isApplication: false },
        2: { provider: 'CREDIBANCO', isApplication: true },
        3: { provider: 'CREDIBANCO', isApplication: false },
        4: { provider: 'CREDIBANCO', isApplication: false },
        6: { provider: 'REDEBAN', isApplication: true },
        7: { provider: 'REDEBAN', isApplication: false }
      }
    }
  },

  computed: {
    typeCatalog () {
      return listTef.map(item => {
        const value = Number(item.valueCredential)
        const rule = this.typeRules[value]
        const integrationName = item.textCredential.toUpperCase()

        return {
          value,
          text: item.textCredential,
          provider: rule
            ? rule.provider
            : integrationName.includes('REDEBAN')
              ? 'REDEBAN'
              : integrationName.includes('WOMPI')
                ? 'WOMPI'
                : 'CREDIBANCO',
          isApplication: rule
            ? rule.isApplication
            : integrationName.includes('APLICACIONES')
        }
      })
    },

    terminalIntegrationsMeta () {
      if (!this.terminal) {
        return []
      }

      return this.terminal.integrations.map(integration => {
        const typeCode = Number(integration.type_tef)
        const catalogType = this.typeCatalog.find(type => type.value === typeCode)

        if (catalogType) {
          return catalogType
        }

        const integrationName = (integration.name_tef || '').toUpperCase()
        const rule = this.typeRules[typeCode]
        const provider = integrationName.includes('REDEBAN')
          ? 'REDEBAN'
          : integrationName.includes('WOMPI')
            ? 'WOMPI'
            : 'CREDIBANCO'

        return {
          value: typeCode,
          text: integration.name_tef || `Tipo ${typeCode}`,
          provider: rule ? rule.provider : provider,
          isApplication: rule ? rule.isApplication : integrationName.includes('APLICACIONES')
        }
      })
    },

    hasApplicationsIntegration () {
      return this.terminalIntegrationsMeta.some(type => type.isApplication)
    },

    availableTypes () {
      if (!this.provider) {
        return []
      }

      const providerTypes = this.typeCatalog
        .filter(type => type.provider === this.provider)
        .map(type => ({ text: type.text, value: type.value, isApplication: type.isApplication }))

      if (!providerTypes.length) {
        return []
      }

      if (this.hasApplicationsIntegration) {
        return []
      }

      if (this.terminalIntegrationsMeta.length) {
        return providerTypes.filter(type => !type.isApplication)
      }

      return providerTypes
    },

    providerOptions () {
      if (!this.terminal) {
        return this.providers
      }

      if (this.hasApplicationsIntegration) {
        return []
      }

      return this.providers.filter(provider => {
        return !this.terminalIntegrationsMeta.some(
          integration => integration.provider === provider.value
        )
      })
    },

    providerConfigured () {
      if (!this.terminal || !this.provider) {
        return false
      }

      return this.terminalIntegrationsMeta.some(
        integration => integration.provider === this.provider
      )
    }
  },

  watch: {
    provider () {
      this.typeTef = null
      this.rows = []
      this.file = null
      this.message = ''
      this.messageType = 'info'
    },
    typeTef () {
      this.rows = []
      this.file = null
      this.message = ''
      this.messageType = 'info'
    }
  },

  methods: {
    async loadExcel (file) {
      this.rows = []
      this.message = ''
      this.messageType = 'info'

      if (!file || !this.typeTef) {
        return
      }

      try {
        const excelRows = await readXlsFile(file)
        const hasHeader = excelRows.length &&
          typeof excelRows[0][0] === 'string' &&
          /terminal|store|c[oó]digo/i.test(excelRows[0][0])
        const headers = hasHeader ? excelRows[0] : null
        const dataRows = hasHeader ? excelRows.slice(1) : excelRows
        const parsedRows = dataRows
          .filter(row =>
            row.some(value => value !== null && value !== undefined && value !== '')
          )
          .map(row => this.buildRow(row, headers))

        if (parsedRows.some(row => row === null)) {
          this.message =
            'El archivo contiene filas sin un código de terminal válido.'
          this.messageType = 'error'
          return
        }

        if (
          this.terminal &&
          (parsedRows.length !== 1 ||
            parsedRows[0].code_store !== Number(this.terminal.code_store))
        ) {
          this.message =
            'El archivo debe contener únicamente el code_store de la terminal seleccionada.'
          this.messageType = 'error'
          return
        }

        this.rows = parsedRows
      } catch (error) {
        this.message = 'No fue posible leer el archivo Excel seleccionado.'
        this.messageType = 'error'
      }
    },

    getColumnIndex (headers, aliases) {
      if (!headers) {
        return -1
      }

      const normalizedAliases = aliases.map(alias =>
        String(alias).toLowerCase().trim()
      )
      return headers.findIndex(header => {
        const normalizedHeader = String(header || '').toLowerCase().trim()
        return normalizedAliases.includes(normalizedHeader)
      })
    },

    getCellValue (columns, headers, aliases, fallbackIndex) {
      const index = this.getColumnIndex(headers, aliases)
      if (index >= 0) {
        return columns[index]
      }
      return columns[fallbackIndex]
    },

    buildRow (columns, headers = null) {
      const codeStore = Number(this.getCellValue(
        columns,
        headers,
        ['terminal hiopos', 'codigo terminal hiopos', 'code_store'],
        0
      ))
      if (!codeStore) {
        return null
      }

      const establishmentRaw = this.getCellValue(
        columns,
        headers,
        ['establecimiento', 'establishment_name', 'nombre establecimiento'],
        null
      )
      const establishmentName = establishmentRaw
        ? String(establishmentRaw).trim()
        : null

      const hasEstablishmentColumn = headers
        ? this.getColumnIndex(
          headers,
          ['establecimiento', 'establishment_name', 'nombre establecimiento']
        ) >= 0
        : (
            (this.typeTef === 1 || this.typeTef === 3)
              ? columns.length >= 11
              : columns.length >= 4
          )
      const offset = hasEstablishmentColumn ? 1 : 0

      let dataIntegration
      if (this.typeTef === 1 || this.typeTef === 3) {
        dataIntegration = {
          code_store: codeStore,
          password: columns[1 + offset],
          username: columns[2 + offset],
          client_id: columns[3 + offset],
          url_token: columns[4 + offset],
          grant_type: columns[5 + offset],
          url_services: columns[6 + offset],
          client_secret: columns[7 + offset],
          codigo_comercio: columns[8 + offset],
          codigo_terminal: columns[9 + offset]
        }
      } else {
        dataIntegration = {
          code_store: codeStore,
          codigo_comercio: columns[1 + offset],
          codigo_terminal: columns[2 + offset]
        }
      }

      return {
        code_store: codeStore,
        establishment_name: establishmentName,
        data_integration: dataIntegration
      }
    },

    async save () {
      this.saving = true
      this.message = ''

      try {
        await this.$store.dispatch(
          'credentialsTef/insertTerminalIntegrationsBulk',
          {
            IdCompania: this.company.IdCompania,
            type_tef: this.typeTef,
            credentials: this.rows,
            user: JSON.parse(atob(localStorage.getItem('uid'))).user
          }
        )

        this.message = 'Integración guardada exitosamente.'
        this.messageType = 'success'
        this.$emit('saved')
      } catch (error) {
        this.message =
          error.response &&
          error.response.data &&
          error.response.data.respuesta
            ? error.response.data.respuesta.Mensaje
            : 'No fue posible guardar la integración.'
        this.messageType = 'error'
      } finally {
        this.saving = false
      }
    },

    cancel () {
      this.provider = null
      this.typeTef = null
      this.file = null
      this.rows = []
      this.saving = false
      this.message = ''
      this.messageType = 'info'
      this.$emit('close')
    },

    downloadFormat () {
      const formats = {
        1: 'SmartPosCredibanco',
        2: 'CredibancoIntegracionApps',
        3: 'SmartPosCredibanco',
        4: 'CredibancoIntegracionTramas',
        6: 'RedebanIntegracionApps',
        7: 'RedebanIntegracionServicios'
      }
      const format = formats[this.typeTef]
      if (!format) {
        return
      }

      const link = document.createElement('a')
      link.href = `/formato/${format}.xlsx`
      link.download = `${format}.xlsx`
      link.click()
    }
  }
}
</script>
